import { InputNumber as AntdInputNumber } from "antd";
import type { InputNumberProps } from "antd";

export const InputNumber = (props: InputNumberProps) => {
  return <AntdInputNumber {...props} />;
};
